export const environment = {
  production: true,
  BaseUrl  : "https://admin.resiliencesoft.com/api/",
  firebaseConfig : { 
    apiKey: "AIzaSyAzRM2g4V8YUDQ8w0yXYk4T327MzLHd91w", 
    authDomain: "rs-appoinment-booking.firebaseapp.com", 
    databaseURL: "https://rs-appoinment-booking.firebaseio.com", 
    projectId: "rs-appoinment-booking",  
    storageBucket: "rs-appoinment-booking.firebasestorage.app", 
    messagingSenderId: "669882480458",  
    appId: "1:669882480458:web:2f7f32d518e9e1a1f233b3" }
};
